import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import { TouchableDiv } from "../Touchable/index";
import cn from 'classnames';


const BarcodeScanner = (props) => {

    const videoRef = useRef(null);
    const reader = useRef(null);
    const [result, setResult] = useState("");

    useEffect(() => {
        if (!videoRef.current) return;

        let cancelled = false;
        import('@zxing/library').then(({ BrowserMultiFormatReader, BarcodeFormat }) => {
            if (cancelled) return;
            reader.current = new BrowserMultiFormatReader();
            const formats = [
                BarcodeFormat.CODE_128,
                BarcodeFormat.EAN_13,
                BarcodeFormat.UPC_A,
            ];
            reader.current.decodeFromConstraints(
                { audio: false, video: { facingMode: 'environment' }, formats },
                videoRef.current,
                (result, error) => {
                    if (result?.text && isValidBarcode(result.text)) {
                        setResult(result.text);
                    }
                    if (error) {
                        console.log(error);
                    }
                }
            );
        });
        return () => {
            cancelled = true;
            reader.current?.reset();
        };
    }, [videoRef])

    useEffect(() =>{
        setTimeout(() => {
            if (result?.length > 0) {
                props.handleBarCodeScan(result);
            }
        }, 2000)
    },[result])

    const isValidBarcode = (barcode) => {
        const isCode128 = /^[\x20-\x7E]+$/.test(barcode);
        const isEAN = /^[0-9]{13}$/.test(barcode);
        const isUPC = /^[0-9]{12}$/.test(barcode);

        return isCode128 || isEAN || isUPC;
    };

    return (
        <div className={cn("w-100 pb-2 position-relative", props.isLandScape ? props.showCheckSeat() ? 'h-72' : 'h-68' : 'h-50')}>
           <TouchableDiv 
                className="position-absolute" 
                style={{right: props.isLandScape ? '190px' : 0, top: props.isLandScape ? '20px' : 0}}
                tabIndex="0" 
                role="button"
                onClick={props.closeBarcodeScanner}
            >
                <Cross fill={props.serverAppTheme?.iconcolor}/> 
          </TouchableDiv>  
            <video className="position-absolute" style={{ bottom: '0.5rem', width:"100%", height:"90%" }} ref={videoRef}/>
        </div>
    )
}

export default BarcodeScanner;